import type { TextareaHTMLAttributes } from "react"
import { cn } from "../utils/cn"

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  error?: boolean
}

export function TextArea({ className, error, ...props }: Props) {
  return <textarea {...props} className={cn("input-base min-h-28", error && "border-rose-300 focus:border-rose-400 focus:ring-rose-100", className)} />
}
